<div class="post">
    <div class="post-info">
        <div class="avatar">
            <img src="assets/temp-avatar.jpg" width="100%">
        </div>
        <div class="info">
            <div class="poster">Summer White</div>
        </div>
    </div>

    <div class="post-body">
        Test
    </div>

</div>

<div class="replies">
    <div>

    </div>
</div>